import PropTypes from 'prop-types';

import ListItem from '@mui/material/ListItem';
import Typography from '@mui/material/Typography';

import classes from './NotifictionItem.module.css';

const NotificationItem = props => {
  return (
    <ListItem
      className={classes.notificationItem}
      button
      component="a"
      href={props.notif.action}
      target="_blank"
    >
      {props.notif.icon == 'UDC' ? (
        <img
          src="https://d1g6c01s9ssd7h.cloudfront.net/logoUDC_small.png"
          alt="UDC"
          className={classes.iconNotificationUser}
        />
      ) : props.notif.icon == 'NEW_DIPLOMA' ? (
        <figure className={classes.itemIcon}>
          <img
            className={classes.imgAvatar}
            src="https://d1g6c01s9ssd7h.cloudfront.net/img/diploma_menu.png"
            alt=""
          />
        </figure>
      ) : props.notif.icon == 'Factura' ? (
        <figure className={classes.itemIcon}>
          <img
            className={classes.imgAvatar}
            src="https://d1g6c01s9ssd7h.cloudfront.net/img/tesoreria_menu.png"
            alt=""
          />
        </figure>
      ) : props.notif.icon == 'book' ? (
        <figure className={classes.itemIcon}>
          <img
            className={classes.imgAvatar}
            src="https://d1g6c01s9ssd7h.cloudfront.net/img/libro_menu.png"
            alt=""
          />
        </figure>
      ) : props.notif.icon == 'academy' ? (
        <figure className={classes.itemIcon}>
          <img
            className={classes.imgAvatar}
            src="https://d1g6c01s9ssd7h.cloudfront.net/img/academia_menu.png"
            alt=""
          />
        </figure>
      ) : (
        ''
      )}
      <div className={classes.contentTitle}>
        <div className={classes.titleBox}>
          <Typography
            variant="subheading"
            className={classes.itemNotiCategory}
            gutterBottom
          >
            {props.notif.category}
          </Typography>
        </div>
        <div className={classes.subtitleBox}>
          <Typography
            variant="body1"
            dangerouslySetInnerHTML={{
              __html: props.notif.message
            }}
            gutterBottom
            className={classes.textNoti}
          />
        </div>
        <div className={classes.subtitleBox}>
          <Typography
            variant="body1"
            dangerouslySetInnerHTML={{
              __html: 'Fecha: ' + props.notif.createdAt
            }}
            gutterBottom
            className={classes.textNotiDate}
          />
        </div>
      </div>
    </ListItem>
  );
};

NotificationItem.propTypes = {
  // eslint-disable-next-line react/require-default-props
  notif: PropTypes.obj
};

export default NotificationItem;
